import { ArtistType } from '@api';
import {
  CompanyAnchor,
  PersonAnchor,
  TouringCardTable,
  TouringCardTableBody,
  TouringCardTableRow,
  TouringCardTableRowLabel,
  TouringCardTableRowValue,
} from '@common';
import { Stack } from '@mantine/core';
import { useTranslation } from 'react-i18next';

type ContractingPartyTablePropsType = {
  artist: ArtistType;
};

export const ContractingPartyTable: React.FC<
  ContractingPartyTablePropsType
> = ({ artist }) => {
  const { t } = useTranslation('artistDetailsFinance');

  const renderPersons = () => {
    if (artist.contractingPartyPersons.length === 0) {
      return t('NO_DATA_PLACEHOLDER', { ns: 'common' });
    }
    return (
      <Stack gap={0}>
        {artist.contractingPartyPersons.map((person) => (
          <PersonAnchor key={person.id} person={person} />
        ))}
      </Stack>
    );
  };

  const renderCompanies = () => {
    if (artist.contractingPartyCompanies.length === 0) {
      return t('NO_DATA_PLACEHOLDER', { ns: 'common' });
    }
    return (
      <Stack gap={0}>
        {artist.contractingPartyCompanies.map((company) => (
          <CompanyAnchor key={company.id} company={company} />
        ))}
      </Stack>
    );
  };

  return (
    <TouringCardTable>
      <TouringCardTableBody>
        <TouringCardTableRow>
          <TouringCardTableRowLabel>
            {t('CONTRACTING_PARTY.PERSONS_LABEL')}
          </TouringCardTableRowLabel>
          <TouringCardTableRowValue>{renderPersons()}</TouringCardTableRowValue>
        </TouringCardTableRow>
        <TouringCardTableRow>
          <TouringCardTableRowLabel>
            {t('CONTRACTING_PARTY.COMPANIES_LABEL')}
          </TouringCardTableRowLabel>
          <TouringCardTableRowValue>
            {renderCompanies()}
          </TouringCardTableRowValue>
        </TouringCardTableRow>
      </TouringCardTableBody>
    </TouringCardTable>
  );
};
